export interface FormInput {
  label: string;
  name: string;
  type: string;
  value: string | boolean;
  required: boolean;
  size: string;
  empty?: boolean;
}

export const startForm: FormInput[] =[
  {
    label: 'Voornaam*',
    name: 'first_name',
    type: 'text',
    value: '',
    required: true,
    size: 'xs12',
  },
  {
    label: 'Achternaam*',
    name: 'last_name',
    type: 'text',
    value: '',
    required: true,
    size: 'xs12',
  },
  {
    label: 'Email*',
    name: 'email',
    type: 'email',
    value: '',
    required: true,
    size: 'xs12',
  },
]

export const PersonalInformationForm: FormInput[] = [
  {
    label: 'Voornaam*',
    name: 'first_name',
    type: 'text',
    value: '',
    required: true,
    size: 'xs6',
    empty: false,
  },
  {
    label: 'Achternaam*',
    name: 'last_name',
    type: 'text',
    value: '',
    required: true,
    size: 'xs6',
    empty: false,
  },
  {
    label: 'Geboortedatum*',
    name: 'birthday_at',
    type: 'hidden',
    value: '',
    required: true,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'land*',
    name: 'country',
    type: 'hidden',
    value: '',
    required: true,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Postcode*',
    name: 'zip_code',
    type: 'text',
    value: '',
    required: true,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Huisnummer*',
    name: 'address_number',
    type: 'number',
    value: '',
    required: true,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Toevoeging',
    name: 'address_addition',
    type: 'text',
    value: '',
    required: false,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Handmatige invoer',
    name: 'custom_address_input',
    type: 'text',
    value: false,
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Straat*',
    name: 'street',
    type: 'text',
    value: '',
    required: true,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'stad',
    name: 'city',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Aanvullende adres info',
    name: 'address_additional_info',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Mobiel nummer*',
    name: 'phone',
    type: 'number',
    value: '',
    required: true,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Bedrijfsnaam',
    name: 'company',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Email*',
    name: 'email',
    type: 'text',
    value: '',
    required: true,
    size: 'xs12',
    empty: false,
  },
  {
    label: '',
    name: 'extra_address',
    type: '',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Bedrijfsnaam',
    name: 'extra_company',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Land',
    name: 'extra_country',
    type: 'hidden',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Postcode',
    name: 'extra_zip_code',
    type: 'text',
    value: '',
    required: false,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Huisnummer',
    name: 'extra_address_number',
    type: 'text',
    value: '',
    required: false,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Toevoeging',
    name: 'extra_address_addition',
    type: 'text',
    value: '',
    required: false,
    size: 'xs4',
    empty: false,
  },
  {
    label: 'Handmatige invoer',
    name: 'custom_extra_address_input',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Straat',
    name: 'extra_street',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Stad',
    name: 'extra_city',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
  {
    label: 'Aanvullende adres info',
    name: 'extra_address_additional_info',
    type: 'text',
    value: '',
    required: false,
    size: 'xs12',
    empty: false,
  },
]
